export const APPLY_CHANGE_REQUEST = 'profileChangeRequests@apply-change-request';
export const PUBLISH_CHANGE_REQUEST = 'profileChangeRequests@publish-change-request';
export const CANCEL_MY_CHANGE_REQUEST = 'profileChangeRequests@cancel-my-change-request';
export const REVIEW_CHANGE_REQUEST = 'profileChangeRequests@review-change-request';
